// extracted by mini-css-extract-plugin
module.exports = {"newTicketButton":"styles_newTicketButton__1EAjq","box-BTN":"styles_box-BTN__2yQ8K"};